// Copyright (c) 2016 Deere & Company

import './product-status-link.scss';
import React, {PropTypes} from 'react';
import ActionLink from '../../../shared/components/action-link';
import {FormattedMessage} from 'react-intl';
import Modal from '../../shared/state/modal';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import StatusChangeRequestModal from './status-change-request-modal/status-change-request-modal';
import {getProductStatusClassName} from '../services/product-status';
import {translate} from '../../../shared/services/translation-service';

function handleClick() {

    this.changeModalVisibility(true);

}

const ProductStatusLink = props =>

    <div className='product-status-link'>
        <span className='product-status-label'>
            <FormattedMessage id='STATUS'/>
        </span>
        <span className='status'>
            <span className={getProductStatusClassName(props.product.status[0])}/>
            <span className='status-primary'>{props.product.status[0].value}</span>
            {
                props.product.status.length > 1 &&
                    <ActionLink
                        isDisabled={false}
                        label={translate('MORE')}
                        onClick={props::handleClick}
                        type='button-link'
                    />
            }
        </span>
        <StatusChangeRequestModal
            changeModalVisibility={props.changeModalVisibility}
            product={props.product}
            productStatusChangeModal={props.productStatusChangeModal}
            updateStatus={props.updateStatus}
        />
    </div>;

ProductStatusLink.displayName = 'ProductStatusLink';
ProductStatusLink.propTypes = {
    changeModalVisibility: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    productStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    updateStatus: PropTypes.func.isRequired
};

export default ProductStatusLink;



// WEBPACK FOOTER //
// ./src/product/shared/components/product-status-link.js